export enum ResponseMode {
  kicker = "kicker",
  response = "response"
}
